import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { LineChart, Line, ResponsiveContainer, Tooltip, YAxis } from "recharts";

const DIR = {
  up: { color: "#1E4338", Icon: TrendingUp, label: "Heating up" },
  down: { color: "#C85A32", Icon: TrendingDown, label: "Cooling" },
  flat: { color: "#5C5652", Icon: Minus, label: "Steady" },
};

export const PriceTrendMini = ({ locality }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/insights/locality/${encodeURIComponent(locality)}/trend`, { params: { listing_type: "buy" } })
      .then(({ data }) => setData(data))
      .catch(() => setData({ points: [] }));
  }, [locality]);

  if (!data || !data.points?.length) {
    return <div className="h-14 flex items-center text-[10px] text-[var(--ink-muted)] italic">Trend data loading…</div>;
  }

  const d = DIR[data.direction] || DIR.flat;
  const Icon = d.Icon;

  return (
    <div data-testid={`price-trend-${locality}`}>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-1 text-[11px] font-medium" style={{ color: d.color }}>
          <Icon className="w-3 h-3" />
          <span>{d.label}</span>
          <span className="font-mono">{data.change_pct > 0 ? "+" : ""}{data.change_pct}%</span>
        </div>
        <span className="text-[10px] text-[var(--ink-muted)]">6-mo</span>
      </div>
      <div className="h-10">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data.points}>
            <YAxis hide domain={["auto", "auto"]} />
            <Tooltip
              content={({ active, payload }) =>
                active && payload?.[0] ? (
                  <div className="bg-white px-2 py-1 rounded text-[10px] shadow border border-[var(--line)]">
                    {payload[0].payload.month}: ₹{payload[0].value.toLocaleString("en-IN")}
                  </div>
                ) : null
              }
            />
            <Line type="monotone" dataKey="rate" stroke={d.color} strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
